import React, { Component } from 'react';
import PropTypes from 'prop-types';
import 'jquery';
import { ListSelector } from '@bingads-webui-react/list-selector';

export class FeedAttributeSelectorView extends Component {
  static defaultProps = {
    attributeNames: [],
  };

  renderItem = name => (
    <div className="feed-attribute-name h4 margin-zero">{name}</div>
  );

  render() {
    const { attributeNames, onSelect } = this.props;
    return (
      <div className="feed-attribute-selector">
        <ListSelector
          renderItem={this.renderItem}
          onSelect={onSelect}
          data={attributeNames}
        />
      </div>
    );
  }
}

FeedAttributeSelectorView.propTypes = {
  attributeNames: PropTypes.arrayOf(PropTypes.string),
  onSelect: PropTypes.func.isRequired,
};
